import { useLocation } from 'react-router-dom';

interface ViewProps {
    isDetailPage: boolean;
}

const useAccountDetail = (): ViewProps => {
    const { pathname } = useLocation();

    return {
        isDetailPage: pathname.includes('detail') && pathname.includes('account')
    };
};

export default useAccountDetail;
